import type { WebsiteContent } from './types'

export const intro: WebsiteContent['intro'] = {
  title: 'Who we are',
  subtitle:
    'NXT Humans unites technologists, creatives, researchers, data scientists, and strategists who believe AI should make work easier.',
  description:
    'We help organizations step into a cloudy AI-powered future with tools that are clear, approachable, and built around real human needs. The result is faster decisions, new opportunities, and solutions that create real impact without the complexity.',
}
